import React from 'react';
import PropTypes from 'prop-types';
import Header from '@ff/ui/Header';
import Header2 from '@ff/ui/Header2';
import { mapLoggedInLabel } from '@ff/ui/Header2/utils';
import zIndices from '../../../utils/zIndices';
import { ENABLE_NEW_MENUBAR } from 'client/settings';
import { useLocation } from 'react-router-dom';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import ResponsiveLogo from '@ff/ui/Header2/ResponsiveLogo';

function MenuBar(props) {
  const {
    drawerLinks,
    menubarLinks,
    isLoggedIn,
    ctaButton
  } = props;

  const location = useLocation();
  // Handle URLs for both the old and new configurators
  const isModelSelection = location.pathname.includes('/model');
  const isConfiguratorPath = location.pathname.includes('/configurator');

  if (ENABLE_NEW_MENUBAR) {
    if (isModelSelection || isConfiguratorPath) {
      return (
        <Header2
          drawerLinks={mapLoggedInLabel(drawerLinks, isLoggedIn)}
          menubarLinks={mapLoggedInLabel(menubarLinks, isLoggedIn)}
          ctaButton={ctaButton}
          isLoggedIn={isLoggedIn}
          colorTheme="LIGHT"
          scrollEffect={false}
          zIndex={zIndices['menubar']}
          spacer
          backgroundColor='white'
          logoType='SIMPLE'
        />
      );
    } else {
      return (
        <SimpleHeaderContainer>
          <Box width='fit-content'>
            <ResponsiveLogo type='SIMPLE' />
          </Box>
        </SimpleHeaderContainer>
      )
    }
  }

  return (
    <Container>
      <Header {...props} isLoggedIn={isLoggedIn} color_theme="LIGHT" scroll_effect={false} />
    </Container>
  );
}

MenuBar.propTypes = {
  logo_link: PropTypes.string.isRequired,
  first_set: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
    loggedInLabel: PropTypes.string
  })).isRequired,
  second_set: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
    loggedInLabel: PropTypes.string
  })),
  hero_button: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
    loggedInLabel: PropTypes.string
  }),
  color_theme: PropTypes.string,
  scroll_effect: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired
};

MenuBar.defaultProps = {
  second_set: [],
  hero_button: null,
  color_theme: 'LIGHT',
  scroll_effect: true,
  isLoggedIn: false
}

const Container = styled(Box)({
  zIndex: zIndices['menubar'],
  position: 'relative'
});

const SimpleHeaderContainer = styled(Box)({
  position: 'fixed',
  top: '0',
  zIndex: '2',
  padding: '19px 42px',
  backgroundColor: 'rgba(255, 255, 255, 0.75)',
  backdropFilter: 'blur(10px)',
  width: '100%',
});

export default MenuBar;
